import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from './../../../environments/environment';

export interface MigrationDump {
  s3_prefix: string;
  call4u_user_id: number;
  email: string;
  exported_at: string;
  counts: { [key: string]: number };
  balance: number | null;
  imported: boolean;
}

export interface AvailableDumpsResponse {
  dumps: MigrationDump[];
}

export interface ImportResponse {
  migration_action_id: number;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class MigrationService {
  constructor(private http: HttpClient) {}

  availableDumps(email: string): Observable<AvailableDumpsResponse> {
    const params = new HttpParams().set('email', email);
    return this.http.get<AvailableDumpsResponse>(
      `${environment.apiUrl}/admin/migration/available-dumps`,
      { params }
    );
  }

  import(payload: {
    email: string;
    s3_prefix: string;
    call4u_user_id: number;
    force?: boolean;
  }): Observable<ImportResponse> {
    return this.http.post<ImportResponse>(
      `${environment.apiUrl}/admin/migration/import`,
      payload
    );
  }
}
